import thirdPartyAuthStore from '@src/mobx-store/root-store/auth/third-party-auth-store';
// noinspection SpellCheckingInspection
import xoyoAuthStore from '@src/mobx-store/root-store/auth/xoyo-auth-store';
export { thirdPartyAuthStore, xoyoAuthStore };
